class Pedido {
  constructor(
    num_factura,
    nombre,
    descripcion,
    telefono,
    sena,
    metodo,
    precio_total,
    fecha,
    hora
  ) {
    this.num_factura = num_factura;
    this.nombre = nombre;
    this.descripcion = descripcion;
    this.telefono = telefono;
    this.sena = sena;
    this.metodo = metodo;
    this.precio_total = precio_total;
    this.fecha = fecha;
    this.hora = hora;
  }
}

export default Pedido;
